<template>
  <router-link :to="{ name: 'enterprise-live-map' }" :style="buttonStyle">
    <to-live-map-button
      class="aisea-text-12-400-pure-white"
      buttonText="LiveMapに戻る"
    ></to-live-map-button>
  </router-link>
</template>

<script>
import ToLiveMapButton from "./ToLiveMapButton.vue";

export default {
  name: "ToLiveMapButtonContainer",
  props: {
    isMobileDevice: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ToLiveMapButton,
  },
  methods: {},
  computed: {
    buttonStyle() {
      return this.isMobileDevice
        ? { position: "absolute", top: "20px", left: "100px", "z-index": 3 }
        : { position: "absolute", top: "20px", left: "20px", "z-index": 3 };
    },
  },
};
</script>

<style lang="scss" scoped></style>
